import { KSEF_ROUTES } from '../../modules/ksef/constants/routes';
import { FILTERS } from './ksef-purchases-filters';
import { FILTERS as ARCHIVE_FILTERS } from './archived-ksef-invoices-filters';

export const KSEF_PURCHASES_LISTING_FILTERS = {
  path: KSEF_ROUTES.INVOICES_PURCHASE.path,
  filters: FILTERS,
};

export const KSEF_SALE_LISTING_FILTERS = {
  path: KSEF_ROUTES.INVOICES_SALE.path,
  filters: FILTERS,
};

export const ARCHIVED_KSEF_INVOICES_LISTING_FILTERS = {
  path: KSEF_ROUTES.ARCHIVED_INVOICES_PURCHASE.path,
  filters: ARCHIVE_FILTERS,
};
